// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import {
  Table,
  Button
} from '../'

const renderOverrideTableRows = (originalParameters, overrideParameters) => {
  const keys = [...new Set([...Object.keys(originalParameters), ...Object.keys(overrideParameters)])]  // get unique keys across objects

  return keys.map(key => (
    <tr key={`overrideTable_${key}`}>
      <th className='slds-size_1-of-2 slds-theme_shade slds-text-heading_label slds-cell-wrap'>
        {key}
      </th>
      <td className='slds-size_1-of-4 slds-cell-wrap'>
        {originalParameters.hasOwnProperty(key)
          ? originalParameters[key]
          : '-'
        }
      </td>
      <td className='slds-size_1-of-4 slds-cell-wrap'>
        {overrideParameters.hasOwnProperty(key)
          ? overrideParameters[key]
          : '-'
        }
      </td>
    </tr>
  ))
}


export const CalculationParameters = ({ originalParameters, overrideParameters, overrideInProgress, handleSaveOverride, overrideBorrowableMaxChanged, clientEligibleForLoan }) => (
  <div>
    <Table
      columns={['', 'Original', 'Override']}
      rows={renderOverrideTableRows(originalParameters, overrideParameters)}
      objectRows={true}
      className='slds-no-row-hover table-cells-align_right table-header-cells-align_right'
    />
    <div className='slds-grid'>
      <Button
        type='brand'
        disabled={!overrideBorrowableMaxChanged || overrideInProgress || !clientEligibleForLoan}
        onClick={handleSaveOverride}
        minWidth={175}
        className='slds-m-top_small slds-m-bottom_medium slds-col_bump-left'>
        {overrideInProgress
          ? 'Applying...'
          : 'Apply change'
        }
      </Button>
    </div>
  </div>
)

CalculationParameters.propTypes = {
  originalParameters: PropTypes.shape({
    'Loan amount applied for': PropTypes.string,
    'Max monthly repayment': PropTypes.string,
    'Max borrowable': PropTypes.string,
    'Max borrowable for this product': PropTypes.string,
    'Eligible loan amount': PropTypes.string,
    'Reason for lower loan amount than applied for': PropTypes.object,
    'Client payroll cycle': PropTypes.string
  }).isRequired,
  overrideParameters: PropTypes.shape({
    'Loan amount applied for': PropTypes.string,
    'Max monthly repayment': PropTypes.string,
    'Max borrowable': PropTypes.string,
    'Max borrowable for this product': PropTypes.string,
    'Eligible loan amount': PropTypes.string,
    'Reason for lower loan amount than applied for': PropTypes.object,
    'Client payroll cycle': PropTypes.string
  }).isRequired,
  overrideInProgress: PropTypes.bool.isRequired,
  handleSaveOverride: PropTypes.func.isRequired,
  overrideBorrowableMaxChanged: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/creditapplication-modal/CalculationParameters.js